// extracted by mini-css-extract-plugin
export default {"quick-see":"QuickSee_quick-see__vyy5C","quick-title":"QuickSee_quick-title__zhEo+","quick-list":"QuickSee_quick-list__mVhS6","quick-item":"QuickSee_quick-item__VqE5a"};